export const ACTION_TYPE = {
  INIT_CATEGORIES: "INIT_CATEGORIES",
  INIT_VIDEOS: "INIT_VIDEOS",
  CATEGORY: "CATEGORY",
  SORT_BY: "SORT_BY",
  SEARCH: "SEARCH",
  LOG_OUT: "LOG_OUT",
  HISTORY: "HISTORY",
  WATCH_LATER: "WATCH_LATER",
  LIKE: "LIKE",
  ADD_PLAYLIST: "ADD_PLAYLIST",
  VIDEO_TO_PLAYLIST: "VIDEO_TO_PLAYLIST",
  ADD_COMMENT: "ADD_COMMENT",
  SORT_BY_DATE: "SORT_BY_DATE",
};
